import { Pagination } from "react-admin";

const CustomPagination = (props) => {
  return <Pagination rowsPerPageOptions={[50, 100, 200, 500]} {...props} />;
};

export { CustomPagination };
